/**
 * Routes every login / register entry point through the new customer accounts
 * flow (/customer_identity/login) so the shopper comes back to the page they
 * started on instead of landing on /account.
 */
(function () {
  var AUTH_HREF_FRAGMENTS = [
    '/account/login',
    '/account/register',
    '/customer_authentication',
    '/customer_identity',
    '/authentication/',
    'shopify.com/authentication',
  ];

  function loginUrl() {
    return '/customer_identity/login?return_to=' + encodeURIComponent(window.location.pathname);
  }

  function isAuthHref(href) {
    if (!href) return false;
    return AUTH_HREF_FRAGMENTS.some(function (fragment) {
      return href.indexOf(fragment) > -1;
    });
  }

  // Yotpo renders its own login/join buttons. Only intercept the ones whose
  // visible label is clearly a login or join action — anything else (e.g.
  // "Complete Program Signup") must keep Yotpo's own click handler.
  function isYotpoAuthButton(el) {
    if (
      !el.classList.contains('yotpo-login-link') &&
      !el.classList.contains('yotpo-register-link')
    ) {
      return false;
    }

    var label = el.querySelector('.yotpo-button-label');
    var text = label ? label.textContent.trim().toLowerCase() : '';

    return (
      text.indexOf('log in') > -1 ||
      text.indexOf('login') > -1 ||
      (text.indexOf('join') > -1 && text.indexOf('free') > -1)
    );
  }

  document.addEventListener(
    'click',
    function (e) {
      var path = e.composedPath ? e.composedPath() : [e.target];

      for (var i = 0; i < path.length; i++) {
        var el = path[i];
        if (!el || el.nodeType !== 1) continue;

        var isAuthAnchor = el.tagName === 'A' && isAuthHref(el.getAttribute('href') || el.href);

        if (isAuthAnchor || isYotpoAuthButton(el)) {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = loginUrl();
          return;
        }
      }
    },
    true
  );
})();
